import { render, staticRenderFns } from "./businessPlan.vue?vue&type=template&id=d31f0862&scoped=true"
import script from "./businessPlan.vue?vue&type=script&lang=ts"
export * from "./businessPlan.vue?vue&type=script&lang=ts"
import style0 from "./businessPlan.vue?vue&type=style&index=0&id=d31f0862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31f0862",
  null
  
)

export default component.exports